import React from 'react'

import { Content } from './common/Content/Content'
import { Header } from './common/Header/Header'

import {
  InterviewsCreatorHandlersContext,
  InterviewsCreatorStateContext,
} from 'components/modules/creators/TemplatesCreator/tabs/Interviews/context'
import { useContext } from 'hooks'

export const CompetencyCategory = () => {
  const state = useContext(InterviewsCreatorStateContext)!
  const handlers = useContext(InterviewsCreatorHandlersContext)!

  const { activeSection, language, isCategoryDeletable } = state
  const { handleDeleteCategoryOpen, handleEditCategoryOpen } = handlers

  const { competency, edited, questions, scoreable, title } = activeSection

  return (
    <React.Fragment>
      <Header
        categoryName={title}
        onDeleteCategoryOpen={handleDeleteCategoryOpen}
        onEditCategoryOpen={handleEditCategoryOpen}
        {...{
          competency,
          edited,
          language,
          scoreable,
          isCategoryDeletable,
        }}
      />
      <Content {...{ questions }} />
    </React.Fragment>
  )
}
